/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import type Discussion from 'flarum/common/models/Discussion';

// Accessors for members other extensions install at runtime without shipping typings. Since
// `@types/modules.d.ts` does not re-declare foreign surfaces, the `any` cast each one needs is
// confined to this file rather than spread over every call site.

/**
 * flarum/approval is optional, so a forum without it treats every discussion as approved.
 */
export function isApproved(discussion: Discussion): boolean {
	if (!app.initializers.has('flarum-approval')) {
		return true;
	}

	return (discussion as any).isApproved();
}
